var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4800_1197",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4800_1197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 3.83301C16.2754 3.83301 16.6993 4.0086 17.0118 4.32116C17.3244 4.63372 17.5 5.05765 17.5 5.49967V7.38967C17.7534 7.53595 17.9638 7.74634 18.11 7.9997C18.2563 8.25306 18.3333 8.54045 18.3333 8.83301V12.1663C18.3333 12.4589 18.2563 12.7463 18.11 12.9997C17.9638 13.253 17.7534 13.4634 17.5 13.6097V15.4997C17.5 15.9417 17.3244 16.3656 17.0118 16.6782C16.6993 16.9907 16.2754 17.1663 15.8333 17.1663H4.16667C3.72464 17.1663 3.30072 16.9907 2.98816 16.6782C2.67559 16.3656 2.5 15.9417 2.5 15.4997V5.49967C2.5 5.05765 2.67559 4.63372 2.98816 4.32116C3.30072 4.0086 3.72464 3.83301 4.16667 3.83301H15.8333ZM15.8333 5.49967H4.16667V15.4997H15.8333V13.833H12.5C11.6304 13.833 10.7952 13.4932 10.1726 12.886C9.55004 12.2788 9.1894 11.4524 9.16766 10.583C9.14591 9.71368 9.46477 8.87024 10.0562 8.2327C10.6476 7.59515 11.4648 7.21398 12.3333 7.17051L12.5 7.16634H15.8333V5.49967ZM16.6667 8.83301H12.5C12.058 8.83301 11.634 9.0086 11.3215 9.32116C11.0089 9.63372 10.8333 10.0576 10.8333 10.4997C10.8333 10.9417 11.0089 11.3656 11.3215 11.6782C11.634 11.9907 12.058 12.1663 12.5 12.1663H16.6667V8.83301ZM13.3333 9.66634C13.5543 9.66634 13.7663 9.75414 13.9226 9.91042C14.0789 10.0667 14.1667 10.2787 14.1667 10.4997C14.1667 10.7207 14.0789 10.9326 13.9226 11.0889C13.7663 11.2452 13.5543 11.333 13.3333 11.333C13.1123 11.333 12.9004 11.2452 12.7441 11.0889C12.5878 10.9326 12.5 10.7207 12.5 10.4997C12.5 10.2787 12.5878 10.0667 12.7441 9.91042C12.9004 9.75414 13.1123 9.66634 13.3333 9.66634Z",
    fill: "black"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4800_1197)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9.375,
    y: -12,
    width: 37.5,
    height: 38.75,
    fill: "#7459AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4800_1197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallerIcon);
export default __webpack_public_path__ + "static/media/wallerIcon.eb778b145ae9c60a7d086af5db2e9510.svg";
export { ForwardRef as ReactComponent };